module.exports = (__webpack_require__(7))(455);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/@angular/router/esm5/router.js from dll-reference vendor
// module id = 1
// module chunks = 0